<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <div class="mb-3 text-danger" v-if="currentData.invoice_status == 'VOID'">
          {{ currentData.invoice_status }} ( {{ currentData.updated_at }})
        </div>
        <!-- /add -->
        <div class=" card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="update">
              <div class="row">
                <div class="col-lg-4 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Invoice </label>
                    <input type="text" v-model="currentData.invoice_no" placeholder="" disabled />
                  </div>

                </div>

                <div class="col-lg-4 col-sm-6 col-12" v-if="currentData.quotations_no != ''">
                  <div class="form-group">
                    <label>Quotations </label>
                    <input type="text" v-model="currentData.quotations_no" placeholder="" disabled />
                  </div>

                </div>
                <div class="col-lg-4 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Customer</label>
                    <input type="text" v-model="currentData.nama_customer" placeholder="" disabled />
                  </div>

                </div>
                <div class="col-lg-4 col-sm-6 col-12">
                  <div class="form-group" style="margin-bottom: 0px!important;">
                    <label>Invoice Date</label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <datepicker class="picker" v-model="currentData.invoice_date" :editable="true" :clearable="false"
                        required />
                      <a class="addonset">
                        <img src="@/assets/img/icons/calendars.svg" alt="img" />
                      </a>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-sm-6 col-12">
                  <div class="form-group" style="margin-bottom: 0px!important;">
                    <label>Due Date</label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <datepicker class="picker" v-model="currentData.due_date" :editable="true" :clearable="false"
                        required />
                      <a class="addonset">
                        <img src="@/assets/img/icons/calendars.svg" alt="img" />
                      </a>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-sm-6 col-12">
                  <div class="form-group">
                    <div class="d-flex justify-content-between ">
                      <label>Bank </label>
                      <!-- <vue-feather type="plus-circle" class="text-primary" style="cursor: pointer;"></vue-feather> -->
                    </div>
                    <model-select :options="data_bank" placeholder="Select Bank" v-model="this.bank_selected"
                      style="z-index:100">
                    </model-select>
                  </div>
                </div>


                <!-- table item -->
                <div class="row  ">
                  <div class="col-12  mt-4 mb-2 d-flex gap-2 align-items-end justify-content-between">
                    <div class="">
                      Table Item
                    </div>
                    <vue-feather type="plus-circle" class="text-primary" style="cursor: pointer;" @click="addItem"
                      v-if="update_akses && currentData.invoice_status == 'ACTIVE'"></vue-feather>

                  </div>

                </div>

                <div class="row ">
                  <div class="col-12 ">
                    <div class=" table-responsive mb-3">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Product Name</th>
                            <th>Description</th>
                            <th>Marketing</th>
                            <th>Qty</th>
                            <th>Price</th>

                            <!-- <th>Discount</th> -->
                            <th>Total</th>
                            <th>Action</th>

                          </tr>
                        </thead>
                        <tbody>

                          <tr v-for="(item, index) in currentData.invoice_detail" :key="item.id">
                            <td>
                              {{ index + 1 }}
                            </td>

                            <td>
                              {{ item.name }}
                            </td>
                            <!-- <td v-html="item.deskripsi" class="text-start text-wrap"> -->
                            <td v-html="convertNewlinesToBr(item.deskripsi)" class="text-start text-wrap">


                            </td>
                            <td>
                              {{ item.nama_marketing }}
                            </td>
                            <td>

                              {{ item.qty }}
                            </td>
                            <td>
                              <span v-if="item.discount_amount == 0">
                                {{ rupiah(item.rate) }}
                              </span>
                              <span v-else>
                                <span class="text-decoration-line-through">
                                  {{ rupiah(item.rate) }}
                                </span>
                                <span v-if="item.discount_type == 'rupiah'">
                                  {{ rupiah(item.item_calculated_discount) + '(' +
                                    rupiah(parseInt(item.discount_amount)) + ')' }}

                                </span>
                                <span v-else>
                                  {{ rupiah(item.item_calculated_discount) + '(' + parseInt(item.discount_amount) + '%)'
                                  }}
                                </span>

                              </span>

                            </td>
                            <td>

                              {{ rupiah(item.item_total) }}
                            </td>
                            <td>

                              <a href="javascript:void(0);" class="me-2"
                                @click="editItem(item.id_items, item.id_marketing, item.qty, item.id, item.id_discount)"
                                v-if="update_akses && currentData.invoice_status == 'ACTIVE'"> <img
                                  src="@/assets/img/icons/edit.svg" alt="img" /></a>
                              <a href="javascript:void(0);" class="text-danger me-2" @click="deleteItem(index)"
                                v-if="update_akses && currentData.invoice_status == 'ACTIVE'">
                                <vue-feather type="trash"></vue-feather></a>
                            </td>

                          </tr>


                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>


                <div class="row ps-2 ms-1  pe-3 me-1 mb-4">
                  <div class="col-12 d-flex justify-content-between w-100 ps-0 pe-0" style="border:1px solid #f8f8f8">
                    <div class="w-100 " style="background-color: #fafbfe!important;">
                      <h4 class="order-total">Subtotal</h4>
                    </div>
                    <div class="w-100">
                      <h4 class="order-amount">{{ rupiah(totalAmount) }}</h4>
                    </div>
                  </div>
                  <div class="col-12 d-flex justify-content-between w-100 ps-0 pe-0" style="border:1px solid #f8f8f8">
                    <div class="w-100 " style="background-color: #fafbfe!important;">
                      <h4 class="order-total">Discount </h4>
                    </div>
                    <div class="w-100 d-flex justify-content-between  align-items-center">
                      <div class="d-flex gap-2">
                        <div class="form-group mb-0">
                          <select class="form-control form-white" data-placeholder="Pilih tipe"
                            v-model="currentData.discount_type">
                            <option value="rupiah">Rp.</option>
                            <option value="persen">%</option>
                          </select>
                        </div>
                        <div class="form-group mb-0">
                          <input type="number" v-model="currentData.calculated_discount" @focus="selectAll"
                            placeholder="" />
                        </div>
                      </div>

                      <div>
                        <h4 class="order-amount">{{ rupiah(currentData.discount_amount) }}</h4>
                      </div>

                    </div>
                  </div>
                  <div class="col-12 d-flex justify-content-between w-100 ps-0 pe-0" style="border:1px solid #f8f8f8">
                    <div class="w-100 " style="background-color: #fafbfe!important;">
                      <h4 class="order-total">Tax {{ currentData.tax_name }}</h4>
                    </div>
                    <div class="w-100 d-flex justify-content-between  align-items-center">
                      <div class="d-flex gap-2">
                        <div class="form-group mb-0">
                          <select class="form-control form-white" data-placeholder="Pilih tipe"
                            v-model="currentData.tax_type" disabled>
                            <option value="persen">%</option>
                            <option value="rupiah">Rp.</option>
                          </select>
                        </div>
                        <div class="form-group mb-0">
                          <input type="number" v-model="currentData.tax_rate" @focus="selectAll" placeholder="" />
                        </div>
                      </div>

                      <div>
                        <h4 class="order-amount">{{
                          rupiah(currentData.tax_amount) }}</h4>
                      </div>

                    </div>

                  </div>
                  <div class="col-12 d-flex justify-content-between w-100 ps-0 pe-0" style="border:1px solid #f8f8f8">
                    <div class="w-100" style="background-color: #fafbfe!important;">
                      <h4 class="order-total">Grand Total</h4>
                    </div>
                    <div class="w-100 d-flex justify-content-end">
                      <div>
                        <h4 class="order-amount">{{ rupiah(currentData.grand_total) }}</h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">


                  <div class="col-12  mt-4 mb-2 d-flex gap-2 align-items-end justify-content-between">
                    <div class="">
                      Table Payment
                    </div>
                    <vue-feather type="plus-circle" class="text-primary" style="cursor: pointer;" @click="addPayment"
                      v-if="totalAmount - total_payment > 0 && update_akses && currentData.invoice_status == 'ACTIVE'"></vue-feather>
                  </div>


                  <div class="col-12 ">
                    <div class=" table-responsive mb-3">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Payment Note </th>
                            <th>Payment Method</th>
                            <th>Payment Date </th>
                            <th>Payment Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr v-for="(item, index) in currentData.invoice_payment" :key="item.id">
                            <td>
                              {{ index + 1 }}
                            </td>
                            <td>
                              {{ item.payment_notes }}
                            </td>
                            <td>
                              {{ item.payment_method }}
                            </td>
                            <td>
                              {{ item.payment_date }}
                            </td>
                            <td>
                              {{ rupiah(item.payment_amount) }}
                            </td>
                            <td>
                              <a href="javascript:void(0);" class="me-2"
                                @click="editPayment(item.id, item.payment_amount, item.payment_method, item.payment_date, item.payment_notes)"
                                v-if="update_akses && currentData.invoice_status == 'ACTIVE'">
                                <img src="@/assets/img/icons/edit.svg" alt="img" /></a>
                              <a href="javascript:void(0);" class="text-danger me-2" @click="deletePayment(index)"
                                v-if="update_akses && currentData.invoice_status == 'ACTIVE'">
                                <vue-feather type="trash"></vue-feather></a>
                            </td>
                          </tr>



                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="col-lg-12 ">
                    <div class="total-order w-100 max-widthauto m-auto mb-4">
                      <ul>
                        <!-- <li class="">
                          <h4>Payment Method</h4>
                          <div class="w-50 d-flex justify-content-end">
                            <div class="w-100">
                              <model-select :options="data_payments" placeholder="Pilih Payment Method"
                                v-model="this.currentData.payment_method">
                              </model-select>
                            </div>
                          </div>

                        </li> -->
                        <li class="total">
                          <h4>Payment Amount</h4>
                          <h5>{{ rupiah(total_payment) }}</h5>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-lg-12 mt-4">

                    <div class="form-group">
                      <label>Note</label>
                      <textarea class="form-control" v-model="currentData.notes">
                    </textarea>
                    </div>

                  </div>
                </div>

                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2"
                    v-if="update_akses && currentData.invoice_status == 'ACTIVE'">Update</button>
                  <router-link to="invoices" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>

  <a href="javascript:void(0);" class="btn btn-adds" data-bs-toggle="modal" data-bs-target="#modaladditeminvoice"
    ref="buttonopenmodaladditeminvoice" hidden><i class="fa fa-plus me-2"></i></a>
  <additeminvoicemodal :marketingdata="data_marketing" :kategoridata="data_kategori" :itemdata="data_item_filter"
    @id_kategori_selected="handleKategoriSelected" @id_item_selected="handleItemSelected" :isMarketing="isMarketing"
    @item_object="handleItemAdd" :itemEdited="itemEdited" :discountdata="data_discount">
  </additeminvoicemodal>
  <a href="javascript:void(0);" class="btn btn-adds" data-bs-toggle="modal" data-bs-target="#modalpayment"
    ref="buttonopenmodalpayment" hidden><i class="fa fa-plus me-2"></i></a>
  <modalpayment :paymentdata="data_payments" :currentData="paymentEdited" @pembayaran_object="handlePaymentAdd"
    :batas_payment="batas_payment" :batas_payment_edit="batas_payment_edit">

  </modalpayment>
</template>

<style scoped>
.order-total {
  color: #637381;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
  border-right: 1px solid #f8f8f8;
  background: #fafbfe;
}

.order-amount {
  color: #212b36;
  font-size: 14px;
  padding: 10px;
  font-weight: 700;
  text-align: right;
}

.fs-7 {
  font-size: 0.5rem;
}

.form-group input[type="number"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}
</style>

<script>


import Cookies from "js-cookie";
import axios from "axios";
import { ShowLoading, CloseLoading, ErrorConnectionTimeOut, base_url, AlertPopup, goPage, AlertBottom, rupiah, rupiahInput } from "@/assets/js/function";
// import modaladditem from "./modaladditem";
import { ModelSelect } from 'vue-search-select';

// import { Form, Field } from "vee-validate";
// import * as Yup from "yup";

export default {
  components: {

    ModelSelect

  },
  name: "edit Invoice",
  data() {
    return {
      filter: true,
      title: "Edit Invoice",
      title1: "edit invoice data",
      config: "",
      api: "",
      foto_ktp_img: "",
      googleMap: "",

      //data
      currentDate: new Date,
      currentData: {
        discount_type: "",
        calculated_discount: "0",
        discount_amount: 0,
        tax_amount: 0,
        tax_rate: 0,
        tax_name: "PPN",
        tax_type: "persen",
        grand_total: 0,
      },

      data_customer: [],
      data_item: [],
      data_kategori: [],
      data_marketing: [],
      data_payments: [],
      data_bank: [],
      data_discount: [],

      //to modaladditem
      data_item_filter: [],
      isMarketing: false,
      itemEdited: {
        marketing_id: "",
        kategori_id: "",
        item_id: "",
        discount_id: "",

      },
      paymentEdited: {
        id: "",
        payment_method: "",
        payment_amount: "",
        payment_notes: "",
        payment_date: new Date(),
      },



      // cek deposit
      status_item_deposit: false,

      //cek payment
      payment_active: "",

      //test 

      batas_payment_edit: 0,

      //rate 
      rate_active: "",

      bankCek: false,
      bank_selected: "",


      update_akses: "",

      statusLoad: 0,

    };
  },
  computed: {
    totalAmount() {

      if (this.currentData.invoice_detail == undefined || this.currentData.invoice_detail.length == 0) {
        return 0;
      } else {
        const total = this.currentData.invoice_detail.reduce((accumulator, currentValue) => accumulator +
          parseInt(currentValue.item_total), 0)
        return total
      }
    },
    total_payment() {
      if (this.currentData.invoice_payment == undefined || this.currentData.invoice_payment.length == 0) {
        return 0;
      } else {
        const total = this.currentData.invoice_payment.reduce((accumulator, currentValue) => accumulator +
          parseInt(currentValue.payment_amount), 0)
        return total
      }
    },

    batas_payment() {
      let payment = 0;
      let amount = 0;
      if (this.currentData.invoice_payment == undefined || this.currentData.invoice_payment.length == 0) {
        payment = 0;
      } else {
        const total = this.currentData.invoice_payment.reduce((accumulator, currentValue) => accumulator +
          parseInt(currentValue.payment_amount), 0)
        payment = total;
      }
      if (this.currentData.invoice_detail == undefined || this.currentData.invoice_detail.length == 0) {
        amount = 0;
      } else {
        const total = this.currentData.invoice_detail.reduce((accumulator, currentValue) => accumulator +
          parseInt(currentValue.item_total), 0)
        amount = total
      }


      return amount - payment;
    }

  },
  watch: {
    'bank_selected': {
      handler(newValue) {
        this.bankCek = false;
      }
    },

    'currentData.discount_type': {
      handler(newValue) {
        if (this.statusLoad == 1) {

          if (this.currentData.calculated_discount == '' || (this.currentData.calculated_discount > 100 && newValue == 'persen')
            || (this.currentData.calculated_discount < 0) || (newValue == 'rupiah' && this.currentData.calculated_discount > this.totalAmount)) {
            this.currentData.calculated_discount = 0;
          }

          if (newValue == 'rupiah') {

            this.currentData.calculated_discount = this.currentData.discount_amount;


          } else if (newValue == 'persen' && this.totalAmount > 0) {
            this.currentData.discount_amount = parseInt(this.currentData.calculated_discount) * (parseInt(this.totalAmount)) / 100;
          } else {
            this.currentData.discount_amount = 0;
          }

          this.currentData.grand_total = this.totalAmount - this.currentData.discount_amount + this.currentData.tax_amount;
        }
      }
    },
    'currentData.calculated_discount': {
      handler(newValue) {
        if (this.statusLoad == 1) {

          if (this.currentData.calculated_discount == '' || (newValue > 100 && this.currentData.discount_type == 'persen')
            || newValue < 0 || (this.currentData.discount_type == 'rupiah' && newValue > this.totalAmount)) {
            this.currentData.calculated_discount = 0;
          }
          if (this.currentData.discount_type == 'rupiah') {
            this.currentData.discount_amount = newValue;

          } else if (this.currentData.discount_type == 'persen' && this.totalAmount > 0) {
            this.currentData.discount_amount = parseInt(newValue) * (parseInt(this.totalAmount)) / 100;
          } else {
            this.currentData.discount_amount = 0;
          }


          this.currentData.grand_total = this.totalAmount - this.currentData.discount_amount + this.currentData.tax_amount;
        }
      }
    },

    'currentData.tax_rate': {
      handler(newValue) {
        if (this.statusLoad == 1) {

          if ((newValue > 100 && this.currentData.tax_type == 'persen') || newValue < 0) {
            this.currentData.tax_rate = 0;
          }

          if (this.currentData.tax_type == 'persen' && this.totalAmount > 0) {
            this.currentData.tax_amount = parseInt(newValue) * (parseInt(this.totalAmount)) / 100;
          } else {
            this.currentData.tax_amount = 0;
          }
          this.currentData.grand_total = this.totalAmount - this.currentData.discount_amount + this.currentData.tax_amount;
        }
      }
    }
  },

  created() {
    ShowLoading();
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }

    // get needed data
    this.getData();

    //get data
    const current_id = JSON.parse(localStorage.getItem('currentData'));

    // call api invoice_detail
    this.invoice_detail(current_id);

  },

  methods: {
    rupiah,
    selectAll(event) {
      // Select all text when input field is focused
      event.target.select();
    },

    convertNewlinesToBr(text) {
      // Replace newlines with <br> tags
      return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
    },

    cek_deposit() {
      const index = this.currentData.invoice_detail.findIndex((record) => record.isdeposit == 'AKTIF');
      const indexPayment = this.data_payments.findIndex((record) => record.nama == 'DEPOSIT');

      const indexCustomer = this.data_customer.findIndex((record) => record.id == this.currentData.customer_detail.id);
      if (index > -1) {
        this.status_item_deposit = true;
      } else {
        this.status_item_deposit = false;
      }

      if ((indexPayment > -1 && index > -1) || (indexCustomer > -1 && this.data_customer[indexCustomer].amount_deposit <= 0)) {
        this.data_payments.splice(indexPayment, 1);

      } else if (indexCustomer > -1 && this.data_customer[indexCustomer].amount_deposit > 0 && indexPayment < 0) {
        this.data_payments.push({ text: 'DEPOSIT (' + rupiah(this.data_customer[indexCustomer].amount_deposit) + ')', value: this.data_payments.length, nama: "DEPOSIT" })
      }

    },
    handleKategoriSelected(item) {
      this.data_item_filter = this.dataItemsFilterKategori(item);
    },

    dataItemsFilterKategori(id) {
      return this.data_item.filter(item => {
        // Apply your filtering condition
        if (item.id_kategori.toString().toLowerCase().includes(id)) {
          // Modify the 'value' attribute here
          item.text = item.nama + ' (' + rupiah(item[this.rate_active]) + ') ';// Your modification logic here;
          return true; // Keep this item in the filtered result
        }
        return false; // Exclude this item from the filtered result
      });
    },
    handleItemSelected(item) {
      this.isMarketing = item;
    },
    handleItemAdd(item) {
      const index = this.data_item.findIndex((record) => record.id == item.id_items);
      const indexMarketing = this.data_marketing.findIndex((record) => record.id == item.id_marketing);
      const indexDiscount = this.data_discount.findIndex((record) => record.id == item.discount_id);
      // const index2 = this.currentData.invoice_detail.findIndex((record) => record.id == item.id);

      // if (index > -1 && index2 > -1) {
      //   console.log('test2');
      //   if (this.data_discount[index].type == 'percent') {
      //     this.currentData.invoice_detail[index2].discount_amount = (parseInt(this.currentData.invoice_detail[index2].rate) * (parseInt(this.data_discount[index].amount) / 100))
      //   }
      //   else if (this.data_discount[index].type == 'rupiah') {
      //     this.currentData.invoice_detail[index2].discount_amount = parseInt(this.data_discount[index].amount)
      //   }

      // }
      const indexKeranjangUpdate = this.currentData.invoice_detail.findIndex(
        (record) => record.id == item.id
      );


      const rate_active = this.cek_rate_active();
      let nama_marketing = "";
      if (this.data_item[index].ismarketing == 'AKTIF' && this.data_marketing[indexMarketing] != undefined) {
        nama_marketing = this.data_marketing[indexMarketing].fullname;
      }
      let rate;
let discount_amount = 0;
let discount_rate = 0;   // ✅ add this: stores the original % or Rp value for display
let id_discount = 0;
let total = 0;
let type_discount = '';
let calculated_price;

rate = this.data_item[index][rate_active];
calculated_price = rate;
total = item.qty * parseInt(rate);

if (indexDiscount > -1) {
  if (this.data_discount[indexDiscount].type == 'percent') {
    discount_rate = parseInt(this.data_discount[indexDiscount].amount);
    discount_amount = parseInt(rate) * (discount_rate / 100);
    id_discount = item.discount_id;
    total = (item.qty * parseInt(rate)) - discount_amount; // overwrite with discounted total
    type_discount = this.data_discount[indexDiscount].type;
    calculated_price = parseInt(rate) - discount_amount;
  }
  else if (this.data_discount[indexDiscount].type == 'rupiah') {
    discount_rate = parseInt(this.data_discount[indexDiscount].amount);
    discount_amount = discount_rate;
    id_discount = item.discount_id;
    total = (item.qty * parseInt(rate)) - discount_amount; // overwrite with discounted total
    type_discount = this.data_discount[indexDiscount].type;
    calculated_price = parseInt(rate) - discount_amount;
  }
}

const itemPrepare = {
  ...item,
  name: this.data_item[index].nama,
  isdeposit: this.data_item[index].isdeposit,
  deskripsi: this.data_item[index].deskripsi,
  nama_marketing: nama_marketing,
  rate: rate,
  item_total: total,
  item_calculated_discount: calculated_price,
  discount_amount: discount_rate,    // ✅ now stores 50 (for %) or 125000 (for Rp)
  id_discount: item.discount_id,
  discount_type: type_discount,
};

      this.cek_deposit();

      if (item.status == 'tambah') {
        itemPrepare.id = this.currentData.invoice_detail.length;


        if (this.status_item_deposit == false && this.data_item[index].isdeposit == 'TIDAK') {
          this.currentData.invoice_detail.push(itemPrepare);
        } else if (this.status_item_deposit == true && this.data_item[index].isdeposit == 'AKTIF') {
          this.currentData.invoice_detail.push(itemPrepare);
        } else if (this.status_item_deposit == false && this.currentData.invoice_detail.length == 0 && this.data_item[index].isdeposit == 'AKTIF') {
          this.currentData.invoice_detail.push(itemPrepare);
        }
        else {
          AlertPopup('error', '', 'item marketing atau item deposit tidak bisa disatukan didalam satu invoice', 2000, true);
        }
      } else {
        if (this.status_item_deposit == false && this.data_item[index].isdeposit == 'TIDAK' && indexKeranjangUpdate > -1) {
          this.currentData.invoice_detail[indexKeranjangUpdate] = itemPrepare;
        } else if ((this.status_item_deposit == true && this.data_item[index].isdeposit == 'AKTIF' && indexKeranjangUpdate > -1) || ((this.status_item_deposit == false && this.data_item[index].isdeposit == 'AKTIF' && indexKeranjangUpdate > -1 && this.currentData.invoice_detail.length == 1))) {
          if (this.data_item[index].isdeposit == 'AKTIF' && this.currentData.invoice_detail.length == 1) {
            this.currentData.invoice_payment = [];
          }
          this.currentData.invoice_detail[indexKeranjangUpdate] = itemPrepare;

        } else if (indexKeranjangUpdate == -1) {
          AlertPopup('error', '', 'item tidak ditemukan', 2000, true);
        }
        else {
          AlertPopup('error', '', 'item marketing atau item deposit tidak bisa disatukan didalam satu invoice', 2000, true);
        }
      }
      this.cek_deposit();

      this.currentData.grand_total = this.totalAmount - this.currentData.discount_amount + this.currentData.tax_amount;
    },

    cek_rate_active() {
      let status = "rate";


      if (this.currentData.customer_detail.id == "0" || this.currentData.customer_detail.id == 0) {
        status = 'rate';
      } else {
        const indexCustomer = this.data_customer.findIndex((record) => record.id === this.currentData.customer_detail.id);

        if (indexCustomer == -1) {
          status = "rate";
        } else if (this.data_customer[indexCustomer].rate == "0") {
          status = "rate";
        } else {
          status = 'rate' + this.data_customer[indexCustomer].rate;
        }
      }
      this.rate_active = status;
      return status;
    },
    deleteItem(indexToRemove) {
      this.currentData.invoice_detail.splice(indexToRemove, 1);
      this.cek_deposit();
      if (this.currentData.invoice_detail.length == 0) {
        this.currentData.invoice_payment = [];
      }
      this.currentData.grand_total = this.totalAmount - this.currentData.discount_amount + this.currentData.tax_amount;
    },
    invoice_detail(current_id) {
      ShowLoading();
      let formData = new FormData();
      formData.append('id', current_id);
      this.api = base_url + 'invoices_details';

      axios.post(this.api, formData, this.config)
        .then((response) => {
          if (response.data.status == true) {
            this.currentData = JSON.parse(JSON.stringify(response.data.data.invoices[0]));

            this.cek_deposit();
            this.currentData.invoice_date = new Date(response.data.data.invoices[0].invoice_date);
            this.currentData.payment_date = new Date(response.data.data.invoices[0].payment_date);
            this.currentData.due_date = new Date(response.data.data.invoices[0].due_date);
            this.cek_rate_active();

            // Normalize types
            if (this.currentData.tax_type != 'persen') {
              this.currentData.tax_type = 'persen';
            }
            if (this.currentData.discount_type != 'persen' && this.currentData.discount_type != 'rupiah') {
              this.currentData.discount_type = 'persen';
            }

            // Bank selection
            if (this.currentData.bank_account_number != '') {
              const indexBank = this.data_bank.findIndex((record) => record.nomor_rekening == this.currentData.bank_account_number);
              this.bank_selected = indexBank > -1 ? this.data_bank[indexBank].id : '';
            }

            // ✅ ALL calculations inside $nextTick only — totalAmount is ready here
            this.$nextTick(() => {
              // Validate discount input
              if (this.currentData.calculated_discount == ''
                || (this.currentData.calculated_discount > 100 && this.currentData.discount_type == 'persen')
                || this.currentData.calculated_discount < 0
                || (this.currentData.discount_type == 'rupiah' && this.currentData.calculated_discount > this.totalAmount)) {
                this.currentData.calculated_discount = 0;
              }

              // Calculate discount amount
              if (this.currentData.discount_type == 'rupiah') {
                this.currentData.calculated_discount = this.currentData.discount_amount;
              } else if (this.currentData.discount_type == 'persen' && this.totalAmount > 0) {
                this.currentData.discount_amount = parseInt(this.currentData.calculated_discount) * this.totalAmount / 100;
              } else {
                this.currentData.discount_amount = 0;
              }

              // Validate tax rate
              if ((this.currentData.tax_rate > 100 && this.currentData.tax_type == 'persen') || this.currentData.tax_rate < 0) {
                this.currentData.tax_rate = 0;
              }

              // Calculate tax amount
              if (this.currentData.tax_type == 'persen' && this.totalAmount > 0) {
                this.currentData.tax_amount = parseInt(this.currentData.tax_rate) * this.totalAmount / 100;
              } else {
                this.currentData.tax_amount = 0;
              }

              // Final grand total
              this.currentData.grand_total = this.totalAmount - this.currentData.discount_amount + this.currentData.tax_amount;

              // ✅ Set LAST so watchers don't interfere during loading
              this.statusLoad = 1;
              CloseLoading();
            });
          }

          if (response.data.status == false) {
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {
          ErrorConnectionTimeOut(error);
        });
    },
    getData() {
      const customer = JSON.parse(localStorage.getItem('customer'));
      customer.forEach((item, index) => {
        let item_prepare = { ...item, value: item.id, text: item.nama };
        this.data_customer.push(item_prepare)
      });


      //get data kategori 
      const kategori = JSON.parse(localStorage.getItem('kategori'));
      kategori.forEach((item, index) => {
        let item_prepare = { ...item, value: item.id, text: item.nama };
        this.data_kategori.push(item_prepare)
      });

      //data payment
      const payment = JSON.parse(localStorage.getItem('payments'));
      payment.forEach((item, index) => {
        let item_prepare = { value: index, text: item.nama.toUpperCase(), nama: item.nama.toUpperCase() };
        this.data_payments.push(item_prepare)
      });

      const marketing = JSON.parse(localStorage.getItem('marketing'));
      marketing.forEach((item, index) => {
        let item_prepare = { ...item, value: item.id, text: item.fullname };
        this.data_marketing.push(item_prepare)
      });

      const item = JSON.parse(localStorage.getItem('item'));
      item.forEach((item, index) => {
        let item_prepare = { ...item, value: item.id, text: item.nama, };
        this.data_item.push(item_prepare)
      });

      if (localStorage.getItem('banks') != null) {
        const bank = JSON.parse(localStorage.getItem('banks'));
        bank.forEach((item, index) => {
          let item_prepare = { ...item, value: item.id, text: item.nama + ' ( No Rek: ' + item.nomor_rekening + ' / ' + item.nama_account + ' )', };
          this.data_bank.push(item_prepare);
        });
      }
      if (localStorage.getItem('discount') != null) {
        const discount = JSON.parse(localStorage.getItem('discount'));
        // console.log(discount)
        discount.forEach((item, index) => {
          let item_prepare;
          if (item.type == 'rupiah') {
            item_prepare = { ...item, value: item.id, text: item.name + ' (' + rupiah(item.amount) + ')' };
          } else {
            item_prepare = { ...item, value: item.id, text: item.name + ' (' + item.amount + '%)' };
          }

          this.data_discount.push(item_prepare);
        });
      }

      const menu = JSON.parse(localStorage.getItem('auth_menu'));
      let url = window.location.pathname.split('/').pop();
      if (url.includes('edit')) {
        url = url.replace('edit', '');
        // console.log(url); 
      }
      const index = menu.findIndex((record) => record.menu === url);

      if (menu[index].update == 'AKTIF') {
        this.update_akses = true;
      } else {
        this.update_akses = false;
      }

    },
    addItem() {
      this.itemEdited = {
        marketing_id: "",
        kategori_id: "",
        discount_id: "",
        item_id: "",
        qty: 1,
        status: 'tambah'
      }

      const openButton = this.$refs.buttonopenmodaladditeminvoice;
      openButton.click();

    },
    editItem(item_id, marketing_id, qty, id, id_discount) {
      const index = this.data_item.findIndex((record) => record.id == item_id);
      const indexKategori = this.data_kategori.findIndex((record) => record.id == this.data_item[index].id_kategori);
      this.itemEdited = {
        marketing_id: marketing_id,
        kategori_id: this.data_kategori[indexKategori].id,
        item_id: item_id,
        discount_id: id_discount,
        qty: qty,
        status: 'edit',
        id: id,
      }
      if (marketing_id > 0) {
        this.isMarketing = true;
      }
      const openButton = this.$refs.buttonopenmodaladditeminvoice;
      this.$nextTick(() => {
        openButton.click();
      });
    },



    //payment
    handlePaymentAdd(item) {

      const indexKeranjangUpdate = this.currentData.invoice_payment.findIndex(
        (record) => record.id == item.id
      );
      item.payment_method = this.data_payments[item.payment_method].nama;

      if (item.status == 'tambah') {
        item.id = this.currentData.invoice_payment.length;

        this.currentData.invoice_payment.push(item);
      } else {
        this.currentData.invoice_payment[indexKeranjangUpdate] = item;
      }
    },


    addPayment() {
      this.paymentEdited = {
        id: "",
        payment_method: "",
        payment_amount: rupiahInput(0),
        payment_notes: "",
        payment_date: new Date(),
        status: 'tambah'
      }

      const openButton = this.$refs.buttonopenmodalpayment;
      openButton.click();


    },
    editPayment(id, payment_amount, payment_method, payment_date, payment_notes) {

      const indexPayment = this.data_payments.findIndex((list) => list.nama == payment_method);
      const paymentobject = {
        id: id,
        payment_method: indexPayment,
        payment_amount: rupiahInput(parseInt(payment_amount)),
        payment_notes: payment_notes,
        payment_date: new Date(payment_date),
        status: 'update'
      }


      // total amount 
      let amount = 0;
      if (this.currentData.invoice_detail == undefined || this.currentData.invoice_detail.length == 0) {
        amount = 0;
      } else {
        const total = this.currentData.invoice_detail.reduce((accumulator, currentValue) => accumulator +
          parseInt(currentValue.item_total), 0)
        amount = total;
      }

      let payment = 0;
      if (this.currentData.invoice_payment == undefined || this.currentData.invoice_payment.length == 0) {
        payment = 0;
      } else {
        const total = this.currentData.invoice_payment.reduce((accumulator, currentValue) => accumulator +
          parseInt(currentValue.payment_amount), 0)
        payment = total
      }

      this.batas_payment_edit = parseInt(amount) - parseInt(payment) + parseInt(payment_amount);

      this.paymentEdited = paymentobject;
      const openButton = this.$refs.buttonopenmodalpayment;
      openButton.click();
    },
    deletePayment(index) {
      this.currentData.invoice_payment.splice(index, 1);



    },

    convertDate(value) {
      const date = new Date(value);

      // Use built-in methods to get year, month, and day
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    update() {
      if (this.currentData.invoice_detail.length == 0) {
        AlertPopup("error", "", 'Please select item for sale', 1500, false);
        return true;
      }


      ShowLoading();
      let formData = new FormData();
      const currentDate = new Date().toISOString().split('T')[0];

      const indexBank = this.data_bank.findIndex((record) => record.id == this.bank_selected);

      const total = this.currentData.invoice_detail.reduce((accumulator, currentValue) => accumulator +
        parseInt(currentValue.item_total), 0);
      let item_id = [];
      let item_qty = [];
      let item_rate = [];
      let item_discount_type = [];
      let item_discount_amount = [];
      let item_is_tax = [];
      let item_name = [];
      let item_calculated_discount = [];
      let item_total = [];
      let item_isdeposit = [];
      let item_id_marketing = [];
      let item_id_discount = [];
      let payment_amount = [];
      let payment_method = [];
      let payment_date = [];
      let payment_notes = [];


      this.currentData.invoice_detail.forEach((item) => {
        item_id.push(item.id_items)
        item_qty.push(item.qty)

        // const indexItem = this.data_items.findIndex((list) => list.id === item.id_items);
        item_rate.push(item.rate);
        item_discount_type.push(item.discount_type);
        item_discount_amount.push(item.discount_amount);
        item_is_tax.push(0);
        item_name.push(item.name);
        item_calculated_discount.push(item.item_calculated_discount);
        item_total.push(item.item_total);
        item_isdeposit.push(item.isdeposit);
        item_id_marketing.push(item.id_marketing);
        item_id_discount.push(item.id_discount);

      });

      this.currentData.invoice_payment.forEach((item) => {
        payment_notes.push(item.payment_notes);
        payment_method.push(item.payment_method);
        payment_amount.push(item.payment_amount);
        payment_date.push(item.payment_date);
      })


      // yang dicomment udh ada
      formData.append("id", this.currentData.id);
      formData.append("invoice_date", this.convertDate(this.currentData.invoice_date)); //udh ada
      formData.append("due_date", this.convertDate(this.currentData.due_date)); //udh ada 
      formData.append("terms", 0); //kosong
      formData.append("po_number", ""); //kosong
      formData.append("id_customer", this.currentData.customer_detail.id); //udh ada
      formData.append("subtotal", total);// udh ada 
      formData.append("discount_type", this.currentData.discount_type); //kosong
      formData.append("discount_amount", this.currentData.discount_amount);//kosong
      formData.append("tax_type", this.currentData.tax_type);//kosong
      formData.append("tax_rate", this.currentData.tax_rate);//kosong
      formData.append("tax_name", 'PPN');//kosong
      formData.append("tax_amount", this.currentData.tax_amount);
      formData.append("payment_date", payment_date); //udh ada
      formData.append("payment_amount", payment_amount);
      formData.append("payment_method", payment_method);
      formData.append("payment_notes", payment_notes); //kosong
      formData.append("unpaid_amount", 0);//kosong
      formData.append("grand_total", this.currentData.grand_total); // udh ada 
      formData.append("notes", this.currentData.notes); //kosong
      formData.append("payment_info", ''); //kosong
      if (indexBank > -1) {
        formData.append("bank_name", this.data_bank[indexBank].nama); //kosong
        formData.append("bank_account_number", this.data_bank[indexBank].nomor_rekening); //kosong
        formData.append("bank_account_name", this.data_bank[indexBank].nama_account); //kosong
      } else {
        formData.append("bank_name", ""); //kosong
        formData.append("bank_account_number", ""); //kosong
        formData.append("bank_account_name", ""); //kosong
      }
      formData.append("calculated_discount", this.currentData.calculated_discount); //kosong

      formData.append("item_id", item_id);// udh ada
      formData.append("item_qty", item_qty); //udh ada
      formData.append("item_rate", item_rate); //udh ada
      formData.append("item_discount_type", item_discount_type); //kosong
      formData.append("item_discount_amount", item_discount_amount); //kosong
      formData.append("item_is_tax", item_is_tax); //kosong
      formData.append("item_name", item_name); //kosong
      formData.append("item_calculated_discount", item_calculated_discount); //kosong
      formData.append("item_total", item_total);// udh ada 
      formData.append("item_isdeposit", item_isdeposit); // udh ada 
      formData.append("item_id_marketing", item_id_marketing);// udh ada
      formData.append("item_id_discount", item_id_discount);// udh ada

      formData.append("id_marketing", this.marketing_id);

      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }
      // CloseLoading();
      // return false;


      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'invoices_update';
      } else {
        this.api = base_url + 'invoices_update';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {
          if (response.data.status == true) {
            AlertBottom(response.data.message);
            goPage('invoices');

            CloseLoading();
          }


          if (response.data.status == false) {
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {

          ErrorConnectionTimeOut(error);
        });
    }


  },

};
</script>
